/* eslint-disable no-unsafe-finally */
import axios from 'axios';
import { config } from '../environment';

const server = config.url;

// keys for actiontypes
export const ActionTypes = {
  UPDATE_SURVEY: 'UPDATE_SURVEY',
  UPDATE_RESULTS: 'UPDATE_RESULTS',
  UPDATE_FAVORITED_RESULTS: 'UPDATE_FAVORITED_RESULTS',
  UPDATE_RESPONSES: 'UPDATE_RESPONSES',
  UPDATE_USER: 'UPDATE_USER',
  AUTH_USER: 'AUTH_USER',
  DEAUTH_USER: 'DEAUTH_USER',
  AUTH_ERROR: 'AUTH_ERROR',
  CHECK_SUPPORT: 'CHECK_SUPPORT',
  INITIALIZE_SPEAKER: 'INITIALIZE_SPEAKER',
  TOGGLE_SPEECH: 'TOGGLE_SPEECH',
  CLEAR_USER_STATUSES: 'CLEAR_USER_STATUSES',
  UPDATE_HASH: 'UPDATE_HASH',
  EMAIL_SENT_SUCCESS: 'EMAIL_SENT_SUCCESS',
  PASSWORD_RESET_SUCCESS: 'PASSWORD_RESET_SUCCESS',
  RESET_ERROR: 'RESET_ERROR',
  CLEAR_FORGOT_PASS_STATUSES: 'CLEAR_FORGOT_PASS_STATUSES',
  CLEAR_ALL_FORGOT_PASS: 'CLEAR_ALL_FORGOT_PASS',
  SWITCH_MODAL_PAGE: 'SWITCH_MODAL_PAGE',
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  SPEAK: 'SPEAK',
  TOGGLE_ALWAYS_POPUP: 'TOGGLE_ALWAYS_POPUP',
  UPDATE_USER_ERROR: 'UPDATE_USER_ERROR',
  SELECT_THEME: 'SELECT_THEME',
  BEELINE_TEXT: 'BEELINE_TEXT',
  TOGGLE_ACCESSIBILITY: 'TOGGLE_ACCESSIBILITY',
  UPDATE_SPEED: 'UPDATE_SPEED',
  CLEAR_ANSWER_HISTORY: 'CLEAR_ANSWER_HISTORY',
};

export function nextQuestion(
  userid,
  surveyid,
  questionid,
  selectedValue,
  generalResult,
  omittedIds,
  correspondingResults,
  history,
) {
  // make POST /:surveyid/:userid request
  return (dispatch) => {
    axios.put(`${server}/api/quiz/${surveyid}/${userid}/${questionid}`, {
      selected_res: selectedValue,
      omitted_ids: omittedIds,
      general_result: generalResult,
      corresponding_results: correspondingResults,
      omitted: false,
    }, { headers: { authorization: localStorage.getItem('token') } })
      .then((result) => {
        if ('complete' in result.data) {
          history.push(`/results/${surveyid}`);
          dispatch({
            type: ActionTypes.UPDATE_SURVEY,
            payload: {
              currQuestion: null,
              numCompleted: 0,
            },
          });
        } else {
          dispatch({
            type: ActionTypes.UPDATE_SURVEY,
            payload: {
              currQuestion: result.data.currQuestion,
              numCompleted: result.data.numCompleted,
            },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function continueSurvey(userid, surveyid, history) {
  return (dispatch) => {
    axios.get(`${server}/api/quiz/continuesurvey/${surveyid}/${userid}`, { headers: { authorization: localStorage.getItem('token') } })
      .then((result) => {
        if ('complete' in result.data) {
          history.push(`/results/${surveyid}`);
          dispatch({
            type: ActionTypes.UPDATE_SURVEY,
            payload: {
              currQuestion: null,
              numCompleted: 0,
              answers: {},
            },
          });
        } else {
          dispatch({
            type: ActionTypes.UPDATE_SURVEY,
            payload: {
              currQuestion: result.data.currQuestion,
              numCompleted: result.data.numCompleted,
              answers: result.data.answers,
            },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function updateSurveyAnswer(questionId, selectedResponse, answers) {
  const updatedAnswers = {
    ...answers,
    [questionId]: selectedResponse,
  };
  return {
    type: ActionTypes.UPDATE_SURVEY,
    payload: { answers: updatedAnswers },
  };
}

export function clearAnswers() {
  return ({
    type: ActionTypes.CLEAR_ANSWER_HISTORY,
  });
}

export function getInProgressSurvey(userid, surveyid) {
  return (dispatch) => {
    axios.get(`${server}/api/quiz/continuesurvey/${surveyid}/${userid}`, { headers: { authorization: localStorage.getItem('token') } })
      .then((result) => {
        if (!('complete' in result.data)) {
          dispatch({
            type: ActionTypes.UPDATE_SURVEY,
            payload: {
              currQuestion: result.data.currQuestion,
              numCompleted: result.data.numCompleted,
            },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function prevQuestion(userid, surveyid, questionid) {
  return (dispatch) => {
    axios.get(`${server}/api/quiz/prevquestion/${surveyid}/${userid}/${questionid}`, { headers: { authorization: localStorage.getItem('token') } })
      .then((result) => {
        dispatch({
          type: ActionTypes.UPDATE_SURVEY,
          payload: {
            currQuestion: result.data.currQuestion,
          },
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

const resultsToBuckets = (results) => {
  const buckets = {};
  results.data.forEach((result) => {
    if (!(result.bucket_cat in buckets)) {
      buckets[result.bucket_cat] = [];
    }
    buckets[result.bucket_cat].push({
      id: result._id,
      title: result.title,
      statement: result.statement,
      priority: result.priority,
    });
  });
  return buckets;
};

export function getResults(userid, surveyid) {
  return (dispatch) => {
    axios.get(`${server}/api/results/${surveyid}/${userid}`, { headers: { authorization: localStorage.getItem('token') } })
      .then((surveyResults) => {
        const buckets = resultsToBuckets(surveyResults);
        dispatch({
          type: ActionTypes.UPDATE_RESULTS,
          payload: { buckets },
        });
      })
      .catch((error) => console.log('error retrieving survey results from backend', error));
  };
}

export function getFavoritedResults(userid) {
  return (dispatch) => {
    axios.get(`${server}/api/favorited-results/${userid}`, { headers: { authorization: localStorage.getItem('token') } })
      .then((surveyResults) => {
        const buckets = resultsToBuckets(surveyResults);
        dispatch({
          type: ActionTypes.UPDATE_FAVORITED_RESULTS,
          payload: { buckets },
        });
      })
      .catch((error) => console.log('error retrieving survey results from backend', error));
  };
}

export function getResponses(userid, surveyid) {
  return (dispatch) => {
    axios.get(`${server}/api/responses/${surveyid}/${userid}`, { headers: { authorization: localStorage.getItem('token') } })
      .then((result) => {
        dispatch({
          type: ActionTypes.UPDATE_RESPONSES,
          payload: result.data,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

export function startSurvey(surveyid, userid, history) {
  return (dispatch) => {
    axios.get(`${server}/api/startquiz/${surveyid}/${userid}`, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({
          type: ActionTypes.UPDATE_SURVEY,
          payload: {
            surveyName: response.data.name,
            surveyid: response.data.id,
            numQuestions: response.data.questions,
            currQuestion: response.data.currQuestion,
            numCompleted: 0,
            genResponse: response.data.gen_response,
          },
        });
        history.push(`/survey/${surveyid}`);
      });
  };
}

export function getUserData(userid) {
  return (dispatch) => {
    axios.get(`${server}/api/user/${userid}`, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({
          type: ActionTypes.UPDATE_USER,
          payload: {
            authenticated: true,
            userid,
            firstName: response.data.first_name,
            lastName: response.data.last_name,
            extraDemographics: response.data.extra_demo,
            occupation: response.data.occupation,
            age: response.data.age,
            email: response.data.email,
            completedSurveys: response.data.completed_surveys,
            inProgressSurveys: response.data.in_progress_surveys,
            favoritedResults: response.data.favorited_results,
          },
        });
      });
  };
}

export function updateUser(userid, body) {
  return (dispatch) => {
    axios.put(`${server}/api/user/${userid}`, body, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        dispatch({
          type: ActionTypes.UPDATE_USER,
          payload: {
            firstName: response.data.first_name,
            lastName: response.data.last_name,
            extraDemographics: response.data.extra_demo,
            occupation: response.data.occupation,
            age: response.data.age,
            email: response.data.email,
            completedSurveys: response.data.completed_surveys,
            inProgressSurveys: response.data.in_progress_surveys,
            favoritedResults: response.data.favorited_results,
            updateSuccess: true,
          },
        });
      })
      .catch(() => {
        dispatch({ type: ActionTypes.UPDATE_USER_ERROR });
      });
  };
}

export function getAllSurveys() {
  return (dispatch) => {
    axios.get(`${server}/api/allquizzes`, { headers: { authorization: localStorage.getItem('token') } })
      .then((response) => {
        const surveys = {};
        console.log(response.data);
        response.data.forEach((survey) => {
          surveys[survey.id] = {
            id: survey.id,
            name: survey.name,
            numCompleted: survey.num_completed,
            numQuestions: survey.num_questions,
            dashboardDescription: survey.dashboard_description,
            openingStatement: survey.opening_statement,
          };
        });
        dispatch({
          type: ActionTypes.UPDATE_SURVEY,
          payload: {
            surveys,
          },
        });
      });
  };
}

export function openModal(currPage) {
  return {
    type: ActionTypes.OPEN_MODAL,
    payload: {
      currPage,
    },
  };
}

export function switchModal(modalPage, endPage = null) {
  return {
    type: ActionTypes.SWITCH_MODAL_PAGE,
    payload: {
      currPage: modalPage,
      endPage,
    },
  };
}

export function closeModal() {
  return {
    type: ActionTypes.CLOSE_MODAL,
  };
}

// trigger to deauth if there is error
// can also use in your error reducer if you have one to display an error message
export function triggerAuthError() {
  return {
    type: ActionTypes.AUTH_ERROR,
  };
}

export function clearUserStatuses() {
  return {
    type: ActionTypes.CLEAR_USER_STATUSES,
  };
}

export function authenticateUser(token, userid, history) {
  return (dispatch) => {
    localStorage.setItem('token', token);
    localStorage.setItem('userid', userid);
    dispatch({
      type: ActionTypes.AUTH_USER,
      payload: {
        userid,
      },
    });
    dispatch({
      type: ActionTypes.CLOSE_MODAL,
    });
    history.push('/dashboard');
  };
}

export function signinUser(user, history) {
  const newObject = { // takes in an object with email and password (minimal user object)
    password: user.password,
    email: user.email,
  };
  return (dispatch) => {
    axios.post(`${server}/api/signin`, newObject)
      .then((response) => {
        authenticateUser(response.data.token, response.data.userid, history)(dispatch);
      })
      .catch((error) => {
        console.log(`Sign In Failed: ${error}`);
        dispatch({ type: ActionTypes.AUTH_ERROR });
      });
  };
}

export function signupUser(object1) {
  // takes in an object with email and password (minimal user object)
  return (dispatch) => { // returns a thunk method that takes dispatch as an argument
  // does an axios.post on the /signup endpoint (only difference from above)
    axios.post(`${server}/api/signup`, object1)
      .then((response) => { // on success does: dispatch({ type: ActionTypes.AUTH_USER });
        localStorage.setItem('token', response.data.token); // sets local storage
        localStorage.setItem('userid', response.data.user._id);
        dispatch({
          type: ActionTypes.UPDATE_USER,
          payload: {
            authenticated: true,
            authError: false,
            userid: response.data.user._id,
            firstName: response.data.user.first_name,
            lastName: response.data.user.last_name,
            extraDemographics: response.data.user.extra_demo,
            occupation: response.data.user.occupation,
            age: response.data.user.age,
            email: response.data.user.email,
            completedSurveys: response.data.user.completed_surveys,
            inProgressSurveys: response.data.user.in_progress_surveys,
          },
        });
      })
      .catch((error) => {
        console.log(`Sign Up Failed: ${error.response}`);
        dispatch({ type: ActionTypes.AUTH_ERROR });
      });
  };
}

export function clearPasswordStatuses() {
  return {
    type: ActionTypes.CLEAR_FORGOT_PASS_STATUSES,
  };
}

export function clearFullPasswordState() {
  return {
    type: ActionTypes.CLEAR_ALL_FORGOT_PASS,
  };
}

export function setResetPassParams(hash, email) {
  return (dispatch) => {
    dispatch({ type: ActionTypes.UPDATE_HASH, payload: { hash, email } });
  };
}

export function sendForgotPasswordEmail(email, url) {
  return (dispatch) => {
    axios
      .put(`${server}/api/forgotpassword`, { email, url })
      .then((response) => {
        dispatch({ type: ActionTypes.EMAIL_SENT_SUCCESS });
      })
      .catch((e) => {
        console.log(e);
        dispatch({ type: ActionTypes.RESET_ERROR });
      });
  };
}

export function resetPassword(hash, password) {
  return (dispatch) => {
    axios
      .put(`${server}/api/resetpassword`, { hash, password })
      .then((response) => {
        dispatch({
          type: ActionTypes.PASSWORD_RESET_SUCCESS,
        });
      })
      .catch((e) => {
        console.log(e);
        dispatch({ type: ActionTypes.RESET_ERROR });
      });
  };
}

export function resetPasswordWithOldPassword(userid, oldPassword, newPassword) {
  return (dispatch) => {
    axios
      .put(`${server}/api/resetpassword-witholdpass`, {
        userid,
        oldPassword,
        newPassword,
      })
      .then((response) => {
        dispatch({
          type: ActionTypes.PASSWORD_RESET_SUCCESS,
        });
      })
      .catch((e) => {
        console.log(e);
        dispatch({ type: ActionTypes.RESET_ERROR });
      });
  };
}

// deletes token from localstorage
// and deauths
export function signoutUser(history) {
  return (dispatch) => {
    localStorage.removeItem('token');
    localStorage.removeItem('userid');
    dispatch({ type: ActionTypes.DEAUTH_USER });
  };
}

export function userData(object) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_USER,
      payload: object,
    });
  };
}
export function toggleAccessibility(event) {
  let newSelected = null;
  let toggleType = 'tts';

  try {
    newSelected = event.target.innerText;
    toggleType = 'beeline';
  } catch (error) {
    console.log(error);
  } finally {
    return (dispatch) => {
      dispatch({
        type: ActionTypes.TOGGLE_ACCESSIBILITY,
        payload: { accessibilityType: toggleType, newSelected },
      });
    };
  }
}
export function toggleSpeech() {
  return {
    type: ActionTypes.TOGGLE_SPEECH,
  };
}

export function selectTheme(event) {
  const newSelected = event.target.innerText;
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SELECT_THEME,
      payload: { newSelected },
    });
  };
}

export function toggleAlwaysPopup() {
  return {
    type: ActionTypes.TOGGLE_ALWAYS_POPUP,
  };
}

export function speak(event) {
  let text = event.target.innerText;
  if (event.target.className === 'beeline-node') {
    text = event.target.parentElement.innerText;
  }
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SPEAK,
      payload: { text },
    });
  };
}

export function beelineText() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.BEELINE_TEXT,
    });
  };
}

export function updateSpeed({ x }) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_SPEED,
      payload: { speed: x },
    });
  };
}
